<template>
  <div>
    <div class="entry sp-subheader">
      {{ $t('POS.SHOP_SETTINGS.STARTPAGE.DESIGN_PREVIEW.SUBHEADING') }}
    </div>
    <ToggleSwitch
      v-model="startPage.designPreviewEnabled"
      label="POS.SHOP_SETTINGS.STARTPAGE.DESIGN_PREVIEW.ENABLE_DESIGN_PREVIEW"
      :disabled="!startPage.designPreviewPossible"
    />
    <LegalLabelInput
      v-model="startPage.designPreviewCaption"
      class="sprd-shop-input"
      maxlength="50"
      :disabled="disabled"
      :label="$t('POS.SHOP_SETTINGS.STARTPAGE.CAPTION_LABEL')"
    />
    <LegalLabelInput
      v-model="startPage.designPreviewButtonCaption"
      class="sprd-shop-input"
      maxlength="50"
      :disabled="disabled"
      :label="$t('POS.SHOP_SETTINGS.STARTPAGE.BUTTON_LABEL')"
    />
  </div>
</template>

<script>
import ToggleSwitch from 'commons/toggleSwitch/ToggleSwitch.vue';
import LegalLabelInput from '../../common/LegalLabelInput.vue';
import { StartPageData } from 'src/app/partnerarea/pos/shop/shopSavable/StartPageData';

export default {
  name: 'DesignPreview',
  components: {
    ToggleSwitch,
    LegalLabelInput,
  },
  mixins: [StartPageData],
  computed: {
    designPreviewPossible() {
      return this.startPage.designPreviewPossible;
    },
    disabled() {
      return (
        !this.startPage.designPreviewEnabled || !this.designPreviewPossible
      );
    },
  },
  watch: {
    designPreviewPossible: {
      handler() {
        this.$store.commit('shop/setLivePreview', {
          path: '',
          section: 'sprd-startpage-design-preview',
          visible: this.designPreviewPossible,
        });
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../startPageCommon.scss';
</style>
